module.exports = __webpack_public_path__ + "media/images/talent/curve-line-036b039338efc318bc79affa64a3ec22.svg";